import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function notOnEtbListBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        {parsedStatusObj.htbSymbol
          ? parsedStatusObj.htbSymbol
          : 'Chosen symbol'}{' '}
        is not on the ETB list.
      </Body3>
    </td>
  );
}
